import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '../../LoadingIndicator';
import StreamedList from '../../StreamedList';
import GallectionListItem from '../../GallectionListItem';
import s from './CollectionList.scss';
var CollectionsList = function (_a) {
    var collectibleDeviation = _a.collectibleDeviation, selectedFolderIds = _a.selectedFolderIds, collections = _a.collections, filterValue = _a.filterValue, headerContent = _a.headerContent, isFetching = _a.isFetching, streamId = _a.streamId, isInitialized = _a.isInitialized, toggleCollectionProp = _a.toggleCollection;
    var t = useTranslation().t;
    var toggleCollection = useCallback(function (_a) {
        var folderId = _a.folderId;
        toggleCollectionProp(folderId, collectibleDeviation.deviationId);
    }, [collectibleDeviation.deviationId, toggleCollectionProp]);
    var collectionsFiltered = collections.filter(function (collection) {
        return (collection &&
            (!filterValue ||
                collection.name.toLowerCase().includes(filterValue.toLowerCase())));
    });
    return (React.createElement(React.Fragment, null,
        headerContent,
        React.createElement(StreamedList, { streamId: streamId, className: s['list'], wrapperClassName: s['scrollable'], skipInitialFetch: true },
            collectionsFiltered.map(function (collection) { return (React.createElement(GallectionListItem, { key: collection.folderId, control: "checkbox", isSelected: selectedFolderIds &&
                    selectedFolderIds.includes(collection.folderId), gallection: collection, subLabel: t('common.deviationCount', { count: collection.size }), onChange: toggleCollection })); }),
            (!isInitialized || isFetching) && (React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] })),
            isInitialized &&
                !isFetching &&
                filterValue &&
                collectionsFiltered.length === 0 && (React.createElement("div", { className: s['empty'] }, t('addToCollectionPopover.empty.noResults'))))));
};
export default CollectionsList;
//# sourceMappingURL=CollectionList.js.map